<template>
  <div class="">
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Views</h1>
        </div>
        <div class="md-toolbar-section-end">
          <router-link
            v-if="isAdmin"
            :to="{ name: 'GraphicalIndex', params: { localId: localId } }"
          >
            <md-button class="md-primary md-raised">
              Conjuntos de imagens
            </md-button>
          </router-link>
          <md-button
            v-if="showConfigurar"
            class="md-primary md-raised"
            @click.stop="() => $refs.slider.toogleTab()"
          >
            Cadastrar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Titulo</md-table-head>
        <md-table-head>Descrição</md-table-head>
        <md-table-head />
      </md-table-row>
      <md-table-row v-for="view in views" :key="view.id" class="pt-2 pb-2">
        <md-table-cell>{{ view.titulo }}</md-table-cell>
        <md-table-cell>{{ view.descricao }}</md-table-cell>
        <md-table-cell>
          <router-link
            :to="{
              name: 'ViewComponentesShow',
              params: { localId: localId, viewId: view.id },
            }"
          >
            <md-button class="md-primary"> Visualizar </md-button>
          </router-link>

          <router-link
            v-if="showConfigurar"
            :to="{
              name: 'ViewComponentes',
              params: { localId: localId, viewId: view.id },
            }"
          >
            <md-button class="md-primary"> Configurar </md-button>
          </router-link>

          <md-button
            v-if="isAdmin"
            class="md-primary"
            @click.stop="() => editarView(view.id)"
          >
            Editar
          </md-button>

          <md-button
            v-if="isAdmin"
            class="md-accent"
            @click="() => (deleteViewId = view.id)"
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="deveAbrirModalDeleteView"
      md-title="Tem certeza?"
      md-content="Deletar uma view é uma ação irreversível. Após concluída os dados da view não poderão ser recuperados"
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-clicked-outside="deleteViewId = null"
      @md-cancel="deleteViewId = null"
      @md-confirm="() => deletarView()"
    />

    <slider-right id="slideLeft" ref="slider" size="30%">
      <ViewCreate
        :local-id="$route.params.localId"
        :view-id="editarViewId"
        @update="() => buscarViews()"
        @close="() => closeCreate()"
      />
    </slider-right>
  </div>
</template>

<script>
import SliderRight from '../../components/SliderLeft.vue'
import ViewCreate from '../../components/view/ViewForm.vue'
import auth from '../../utils/auth'
import http from '../../utils/http'

export default {
  name: 'ViewIndex',
  components: { SliderRight, ViewCreate },
  data() {
    return {
      deleteViewId: null,
      editarViewId: null,
      views: [],
      localId: '',
    }
  },
  computed: {
    deveAbrirModalDeleteView() {
      return this.deleteViewId !== null
    },
    showConfigurar() {
      return auth.canView()
    },
    showVisualizar() {
      return auth.canViewVisualizar()
    },
    isAdmin() {
      return auth.isAdmin()
    },
  },
  async mounted() {
    this.localId = this.$route.params.localId
    if (this.$route.query.openSlider) {
      this.$nextTick(() => {
        this.$refs.slider.toogleTab()
      })
    }
    await this.buscarViews()
  },
  methods: {
    closeCreate() {
      this.$refs.slider.toogleTab()
      this.editarViewId = null
    },
    async editarView(viewId) {
      this.$refs.slider.toogleTab()
      this.editarViewId = viewId
    },
    async buscarViews() {
      const response = await http.get(
        `view/v2/local/${this.$route.params.localId}`
      )

      this.views = response?.views || []
    },
    deletarView() {
      http.delete(`view`, this.deleteViewId).then(() => {
        this.views = this.views.filter((view) => view.id !== this.deleteViewId)
        this.deleteViewId = null
      })
    },
    toCadastrarView() {
      this.$router.push({
        name: 'ViewCadastrar',
        params: { localId: this.localId },
      })
    },
  },
}
</script>
